/**
 * @generated SignedSource<<8f55695fb527ec6475bf6f596666e9e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EvaluationType = "TOP_PERFORMING" | "WORSE_PERFORMING" | "%future added value";
export type KPI = "AGGREGATE_CONVERSION_RATE" | "AVG_DAILY_PURCHASE_VOLUME" | "AVG_DAILY_SPEND" | "CLICK_THROUGH_RATE" | "CONVERSION_RATE" | "COST_PER_ADD_TO_CART" | "COST_PER_COMPLETED_REGISTRATION" | "COST_PER_DONATION" | "COST_PER_ENGAGEMENT" | "COST_PER_INITIATED_CHECKOUT" | "COST_PER_INSTALL" | "COST_PER_LANDING_PAGE_VIEW" | "COST_PER_LEAD" | "COST_PER_LINK_CLICK" | "COST_PER_PURCHASE" | "COST_PER_STORE_LOCATOR" | "COST_PER_TOTAL_PURCHASE" | "COST_PER_TRIAL_STARTED" | "CPM" | "ENGAGEMENT_RATE" | "HOOK_RATE" | "IMPRESSIONS" | "LANDING_PAGE_VIEW_RATE" | "LEAD_CONVERSION_RATE" | "LEAD_RATE" | "PURCHASES" | "PURCHASES_CONVERSION" | "PURCHASES_TO_IMPRESSIONS" | "PURCHASES_TO_LINK_CLICK" | "PURCHASES_TO_LPV" | "REACH" | "RESULT_RATE" | "ROAS" | "SPEND" | "TOTAL_ROAS" | "TRIALS_STARTED" | "TRIALS_STARTED_TO_IMPRESSIONS" | "WEBSITE_PURCHASES" | "%future added value";
export type GetAISummaryRequest = {
  aiDateRange: string;
  brandId: string;
  evaluationType: EvaluationType;
  kpi: KPI;
};
export type PrimaryColorTreemapQuery$variables = {
  input: GetAISummaryRequest;
  skip: boolean;
};
export type PrimaryColorTreemapQuery$data = {
  readonly getPrimaryColorLabelLift?: ReadonlyArray<{
    readonly adsCount: number;
    readonly contentUrls: ReadonlyArray<string>;
    readonly kpiPresent: number | null;
    readonly labelName: string;
    readonly lift: number | null;
    readonly spend: number | null;
  }>;
};
export type PrimaryColorTreemapQuery = {
  response: PrimaryColorTreemapQuery$data;
  variables: PrimaryColorTreemapQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "PrimaryColorLabelLift",
        "kind": "LinkedField",
        "name": "getPrimaryColorLabelLift",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "labelName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lift",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "kpiPresent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "spend",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adsCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contentUrls",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PrimaryColorTreemapQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PrimaryColorTreemapQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "61dc0ff7baaa2b36723f6b6cfa591a50",
    "id": null,
    "metadata": {},
    "name": "PrimaryColorTreemapQuery",
    "operationKind": "query",
    "text": "query PrimaryColorTreemapQuery(\n  $input: GetAISummaryRequest!\n  $skip: Boolean!\n) {\n  getPrimaryColorLabelLift(input: $input) @skip(if: $skip) {\n    labelName\n    lift\n    kpiPresent\n    spend\n    adsCount\n    contentUrls\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d9ea710f14ea8566a272076e7172811";

export default node;
